<app-modal [id]="id" *ngIf="modalLoaded" [large]="true">
  <span modal-title>{{ "historyAction" | language }} - {{ turn.label }} </span>
  <div modal-body>
    <div *ngIf="historyList.length == 0" class="alert alert-info">
        {{ 'noHistory' | language }}
    </div>
    <div *ngIf="historyList.length > 0" class="scrolled">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col">{{ 'ticketDate' | language }}</th>
            <th scope="col">{{ 'attentionDate' | language }}</th>
            <th scope="col">{{ 'queue' | language }}</th>
            <th scope="col">{{ 'preEvaluation' | language }}</th>
            <th scope="col">{{ 'evaluation' | language }}</th>
            <th scope="col">{{ 'desk' | language }}</th>
            <th scope="col">{{ 'user' | language }}</th>
            <th scope="col">{{ 'waitTime' | language }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of historyList">
            <td>{{ p.initdatetime | date: 'HH:mm' }}</td>
            <td>{{ p.deskdatetime | date: 'HH:mm' }}</td>
            <td>{{ p.queuename }}</td>
            <td>{{ p.prekindname }}</td>
            <td>{{ p.kindname }}</td>
            <td>#{{p.desk_id}} - {{ p.deskname }}</td>
            <td>{{ p.deskuser }}</td>
            <td>{{ _utils.getWaitTime(p["initdatetime"], p["deskdatetime"], false, false) + " min" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</app-modal>
